// extracted by mini-css-extract-plugin
export var buttonContainer = "_8j-1";
export var fontSizeSelect = "_8j-3";
export var formatSelect = "_8j-2";
export var formats = "_8j-4";
export var hidden = "_8j-5";
export var icon = "_8j-6";
export var select = "_8j-0";